import { withContextualizedTracking } from 'lib/analytics'
import { CouponsPage } from './CouponsPage'

export default withContextualizedTracking()(CouponsPage)
